import React from 'react'
import Searchbar from 'app/components/Searchbar'
import Button from 'app/components/Button'

interface AuditHeaderProps {
  searchTerm: string
  setSearchTerm: React.Dispatch<React.SetStateAction<string>>
  selectedFramework: string
  onFrameworkChange: (e: React.ChangeEvent<HTMLSelectElement>) => void
  activeFrameworks: string[]
  onAddAudit: () => void
  currentUserRole?: string
  currentAuditContext?: any
}

const AuditHeader: React.FC<AuditHeaderProps> = ({
  searchTerm,
  setSearchTerm,
  selectedFramework,
  onFrameworkChange,
  activeFrameworks,
  onAddAudit,
  currentUserRole,
  currentAuditContext,
}) => {
  return (
    <div className='card-header border-0 mb-8'>
      <div className='d-flex justify-content-between align-items-center w-100'>
        <div className='d-flex align-items-center justify-content-end' style={{gap: '10px'}}>
          <div className='flex-lg-fill'>
            <Searchbar searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
          </div>
          <select
            id='status'
            className='form-select'
            aria-label='Select Status'
            style={{width: '170px'}}
            value={selectedFramework}
            onChange={onFrameworkChange}
          >
            <option value='All'>Framework</option>
            {activeFrameworks.map((framework) => (
              <option key={framework} value={framework}>
                {framework}
              </option>
            ))}
          </select>
        </div>

        {(currentUserRole !== 'Auditor' && !currentAuditContext) && (
          <Button
            btnType='primary'
            onClick={onAddAudit}
          >
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='18'
              height='18'
              viewBox='0 0 24 24'
              fill='none'
              stroke='currentColor'
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
              className='icon icon-tabler icons-tabler-outline icon-tabler-plus mb-1 me-1'
            >
              <path stroke='none' d='M0 0h24v24H0z' fill='none' />
              <path d='M12 5l0 14' />
              <path d='M5 12l14 0' />
            </svg>
            Add Audit
          </Button>
        )}
      </div>
    </div>
  )
}

export default AuditHeader
